module.exports = __webpack_public_path__ + "static/media/profile-7.1f6fe698.png";